import { geoPagesRoutes } from '@/GeoPages/geopages.routes';
const geoPagesModule = {
    routes: geoPagesRoutes
};
export default geoPagesModule;
